import { isArray, isString, isNumber } from 'lodash'
import { SPORT_SERVICE } from '../constants'

/*
  Method for verification of counter updates for sport/category/tournament entities

  Checks is provided sport services contains non zero counter value
  If its ok - entity should be updated or added new one
  On false - entity should be removed
*/
export function verifyCountersBySportServices (sportServices, countersMap) {
  if (isString(sportServices)) {
    const sportServiceCount = countersMap[sportServices]

    // Accepting counters if provided archived sport service
    if (sportServices === SPORT_SERVICE.ARCHIVED) {
      return true
    }

    return (
      (isNumber(sportServiceCount)) && (sportServiceCount > 0)
    )
  }

  if (isArray(sportServices)) {
    for (const sportService of sportServices) {
      // If one of provided sport servies are archived - accepting verification
      if (sportService === SPORT_SERVICE.ARCHIVED) {
        return true
      }

      const sportServiceCount = countersMap[sportService]

      if (
        isNumber(sportServiceCount) && // Counter exist
        (sportServiceCount > 0) // Non zero value
      ) {
        return true
      }
    }
  }

  return false
}
